'use strict';
import * as $j_dev$002echeleb$002escalamigen$002econfig$002e$002dPanel$002dConfig from "./dev.cheleb.scalamigen.config.-Panel-Config.js";
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
function $f_Ldev_cheleb_scalamigen_Form__$init$__V($thiz) {
  $thiz.dt($j_java$002elang$002e$002dObject.$m_s_None$());
  $thiz.du($j_java$002elang$002e$002dObject.$m_s_None$());
}
export { $f_Ldev_cheleb_scalamigen_Form__$init$__V as $f_Ldev_cheleb_scalamigen_Form__$init$__V };
function $f_Ldev_cheleb_scalamigen_Form__withFieldName__T__Ldev_cheleb_scalamigen_Form($thiz, n) {
  $thiz.dt(new $j_java$002elang$002e$002dObject.$c_s_Some(n));
  return $thiz;
}
export { $f_Ldev_cheleb_scalamigen_Form__withFieldName__T__Ldev_cheleb_scalamigen_Form as $f_Ldev_cheleb_scalamigen_Form__withFieldName__T__Ldev_cheleb_scalamigen_Form };
function $f_Ldev_cheleb_scalamigen_Form__withPanelConfig__s_Option__Z__Ldev_cheleb_scalamigen_Form($thiz, label, asTable) {
  $thiz.du(new $j_java$002elang$002e$002dObject.$c_s_Some(new $j_dev$002echeleb$002escalamigen$002econfig$002e$002dPanel$002dConfig.$c_Ldev_cheleb_scalamigen_config_PanelConfig(label, asTable, "srf-field", "srf-label", "srf-panel")));
  return $thiz;
}
export { $f_Ldev_cheleb_scalamigen_Form__withPanelConfig__s_Option__Z__Ldev_cheleb_scalamigen_Form as $f_Ldev_cheleb_scalamigen_Form__withPanelConfig__s_Option__Z__Ldev_cheleb_scalamigen_Form };
